import * as moment from "moment";

export type AllowableSelfServiceCheckInIPAddress = {
    id: string;
    value: string;
    description: string;
    active: boolean;
}

export type CreateAllowableSelfServiceCheckInIPAddress = Omit<AllowableSelfServiceCheckInIPAddress, "id">;

export const isIPAddressValid = (ipAddress: string) => {
    // eslint-disable-next-line max-len
    if (/^(25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.(25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.(25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.(25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])$/.test(ipAddress)) {
        return true;
    }
    return false;
};

export enum EmployeeSelfCheckInStage {
    Start = "Start",
    ProvideSurname = "ProvideSurname",
    ProvideMonthOfBirth = "ProvideMonthOfBirth",
    ProvideDayOfBirth = "ProvideDayOfBirth",
    ConfirmDetails = "ConfirmDetails",
    NoAppointmentFound = "NoAppointmentFound",
    AppointmentFound = "AppointmentFound"
}

export interface EmployeeSelfCheckInStageProps {
    changeState: (nextStage: EmployeeSelfCheckInStage) => void;
}

export interface RestartProps {
    restartButton: JSX.Element;
}

export enum AlphabetLetter {
    A = "A",
    B = "B",
    C = "C",
    D = "D",
    E = "E",
    F = "F",
    G = "G",
    H = "H",
    I = "I",
    J = "J",
    K = "K",
    L = "L",
    M = "M",
    N = "N",
    O = "O",
    P = "P",
    Q = "Q",
    R = "R",
    S = "S",
    T = "T",
    U = "U",
    V = "V",
    W = "W",
    X = "X",
    Y = "Y",
    Z = "Z"
}

export enum Month {
    January = 1,
    February = 2,
    March = 3,
    April = 4,
    May = 5,
    June = 6,
    July = 7,
    August = 8,
    September = 9,
    October = 10,
    November = 11,
    December = 12
}

export enum DayOfMonth {
    First = 1, Second = 2, Third = 3, Fourth = 4, Fifth = 5, Sixth = 6, Seventh = 7, Eighth = 8, Ninth = 9, Tenth = 10,
    Eleventh = 11, Twelfth = 12, Thirteenth = 13, Fourteenth = 14, Fifteenth = 15, Sixteenth = 16, Seventeenth = 17,
    Eighteenth = 18, Nineteenth = 19, Twentieth = 20, TwentyFirst = 21, TwentySecond = 22, TwentyThird = 23,
    TwentyFourth = 24, TwentyFifth = 25, TwentySixth = 26, TwentySeventh = 27, TwentyEighth = 28, TwentyNinth = 29,
    Thirtieth = 30, ThirtyFirst = 31
}

export const MilisecondsInASecond = 1000;

export interface EmployeeSelfCheckInSettingsModel {
    ipAddress: string;
    isIPAddressWhitelisted: boolean;
    secondsOfInactivityBeforeSystemReloads: number;
    secondsThatMessagesAreDisplayedOnScreen: number;
}

export interface EmployeeSelfCheckInSearchModel {
    surnameLetter: string;
    dobMonth: number;
    dobDayOfMonth: number;
}

export interface EmployeeSelfCheckInAppointmentClinicModel {
    appointmentClinicName: string;
    appointmentClinicStartTime: moment.Moment;
}
